import React from 'react';

export default function EarlyBirdIcon() {
  return (
    <svg width="130" height="120" viewBox="0 0 165 150" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d)">
        <circle opacity="0.5" cx="88.4643" cy="57.2857" r="84.4143" fill="white" />
        <circle opacity="0.5" cx="87.9819" cy="57.7681" r="68.4962" fill="white" />
        <circle opacity="0.5" cx="90.3937" cy="57.2857" r="54.5075" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M91.98 67.61C94.18 67.64 93.03 67.28 93.82 71.47C94.17 73.27 94.93 74.78 94.89 76.54L92.87 76.72C92.35 75.1 90.76 69.18 91.98 67.61ZM83.47 77.31C83.03 75.84 80.99 66.74 82.13 65.64C82.89 64.91 87.54 65.27 88.27 65.8C90.13 67.15 88.36 69.15 88.11 70.58C91.82 72.78 93.82 78.42 83.47 77.31ZM100.24 68.93C99.07 68.9 99.89 68.6 98.41 68.85C98.34 68.86 98.2 68.89 98.1 68.94C97.14 71.76 98.92 73.48 98.66 75.82L96.92 76.07C96.1 74.46 95.39 69.13 95.31 67.17C100.87 66.84 96.61 66.87 99.15 66.36C101.19 65.95 100.82 67.76 100.24 68.93ZM104.73 62.11L106.77 61.62C107.95 63.62 108.93 70.61 108.93 73.12C106.32 74.32 103.31 75.4 102.09 72.06C101.53 70.54 101.6 68.66 102.16 67.33C102.93 65.51 103.57 65.59 105.33 64.89L104.73 62.11ZM88.8 55.97C86.5 53.13 91.7 52.15 93.37 53.96C94.22 54.88 95.49 60.15 95.29 61.86C86.98 63.69 88.48 58.62 89.8 57.41C91.56 55.79 91.53 57.52 92.01 55.37C90.11 54.04 90.23 55.61 88.8 55.97ZM95.79 52.51C97.7 52.35 97.46 53.02 98.52 52.36C99.72 51.61 99.33 51.35 100.7 51.94C101.17 53.38 101.21 52.94 100.6 54.29L98.47 54.1C97.45 57.52 99.16 58.86 99.25 61.24L97.13 61.49C96.58 59.56 95.51 54.9 95.79 52.51ZM104.44 54.93C105.14 58.45 106.63 60.03 104.34 60.04C103.08 60.04 103.11 58.97 102.84 57.58C102.37 55.14 101.32 50.14 102.03 48.14L103.8 48.05C103.92 50.63 103.94 52.46 104.44 54.93ZM80.96 62.88C80.27 59.85 79.44 54.29 80.14 50.88L86.37 50.86L85.97 52.96C84.54 52.92 81.66 52.03 81.84 54.31C82 56.21 83.38 54.59 85.47 54.81C85.93 59.49 81.87 55.5 82.43 59.14C82.93 62.39 86.49 60.33 87.22 60.16C87.84 61.53 88.08 61.05 88.19 62.85L80.96 62.88ZM107.14 50.07C108.08 51.58 107.7 53.64 109.97 53.47C110.61 51.89 109.91 50.44 109.93 49.02L111.73 48.68C112.6 52.5 110.83 59.29 106.79 59.26C105.69 56.85 107.19 57.33 108.49 56.07C107.87 54.63 104.53 53.47 105.58 50.32L107.14 50.07ZM105.41 46.49C104.69 44.84 105.25 43.3 107.14 44.49C107.53 45.36 107.36 45.82 107.08 46.57L105.41 46.49ZM94.09 82.45C111.06 82.48 122.51 67.03 120.32 53.75C119.95 51.51 118.08 47.5 118.05 46.86C118 45.74 120.51 41.96 121 41.07L117.15 41.59L116.81 37.9C115.59 38.01 114.08 40.37 113.14 41.13C110.32 39.48 106.68 36.76 101.51 41.26C98.82 43.62 96.81 48.63 94.09 50.61C91.31 50.64 83.9 47.25 81.17 46.07C79.12 45.19 70.95 41.07 69.4 40.93C66.89 44.38 66.61 50.38 68.51 54.47C71.03 59.92 75.21 61.61 76.07 63.47C70.7 65.72 62.7 67.45 56 68.15C58.46 70.58 62.02 68.91 62.04 75.45C64.53 74.58 67.35 70.82 69.4 69.84C70.49 70.34 73.21 73.09 74.57 74.18C76.37 75.63 77.88 76.73 79.96 77.96C83.94 80.33 88.71 82.44 94.09 82.45Z"
          fill="#6AAA43"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M82.1 32C80.33 33.88 78.35 39.13 78.21 42.69C81.08 43.99 90.84 48.46 93.86 48.43C94.53 47.15 96.15 45.61 96.57 44.02C94.12 42.53 91.12 39.9 89.1 38.13C87.97 37.13 83.11 32.44 82.1 32Z"
          fill="#6AAA43"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M85.49 75.23C84.86 74.05 84.81 74.05 84.78 72.46L86.62 71.5C89.13 73.06 89.54 76.2 85.49 75.23ZM84.25 70.49C83.84 69.01 83.74 68.56 84.57 67.25L86.76 67.29C86.85 69.26 85.96 70.29 84.25 70.49ZM83.47 77.31C93.82 78.42 91.82 72.78 88.11 70.58C88.36 69.15 90.13 67.15 88.27 65.8C87.54 65.27 82.89 64.91 82.13 65.64C80.99 66.74 83.03 75.84 83.47 77.31Z"
          fill="#F2F2F2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M80.96 62.88L88.19 62.85C88.08 61.05 87.84 61.53 87.22 60.16C86.49 60.33 82.93 62.39 82.43 59.14C81.87 55.5 85.93 59.49 85.47 54.81C83.38 54.59 82 56.21 81.84 54.31C81.66 52.03 84.54 52.92 85.97 52.96L86.37 50.86L80.14 50.88C79.44 54.29 80.27 59.85 80.96 62.88Z"
          fill="#F0F0F0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M105.73 66.41C106.44 67.68 107.51 73.54 104.56 71.76C103.45 71.09 102.69 66.29 105.73 66.41ZM102.09 72.06C103.31 75.4 106.32 74.32 108.93 73.12C108.93 70.61 107.95 63.62 106.77 61.62L104.73 62.11L105.33 64.89C103.57 65.59 102.93 65.51 102.16 67.33C101.6 68.66 101.53 70.54 102.09 72.06Z"
          fill="#F2F2F2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M92.83 60.45C89.66 60.99 90.24 57.3 92.86 58.06L92.83 60.45ZM88.8 55.97C90.23 55.61 90.11 54.04 92.01 55.37C91.53 57.52 91.56 55.79 89.8 57.41C88.48 58.62 86.98 63.69 95.29 61.86C95.49 60.15 94.22 54.88 93.37 53.96C91.7 52.15 86.5 53.13 88.8 55.97Z"
          fill="#EDEDED"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M109.93 49.02C109.91 50.44 110.61 51.89 109.97 53.47C107.7 53.64 108.08 51.58 107.14 50.07L105.58 50.32C104.53 53.47 107.87 54.63 108.49 56.07C107.19 57.33 105.69 56.85 106.79 59.26C110.83 59.29 112.6 52.5 111.73 48.68L109.93 49.02Z"
          fill="#F1F1F1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M100.24 68.93C100.82 67.76 101.19 65.95 99.15 66.36C96.61 66.87 100.87 66.84 95.31 67.17C95.39 69.13 96.1 74.46 96.92 76.07L98.66 75.82C98.92 73.48 97.14 71.76 98.1 68.94C98.2 68.89 98.34 68.86 98.41 68.85C99.89 68.6 99.07 68.9 100.24 68.93Z"
          fill="#F1F1F1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M95.79 52.51C95.51 54.9 96.58 59.56 97.13 61.49L99.25 61.24C99.16 58.86 97.45 57.52 98.47 54.1L100.6 54.29C101.21 52.94 101.17 53.38 100.7 51.94C99.33 51.35 99.72 51.61 98.52 52.36C97.46 53.02 97.7 52.35 95.79 52.51Z"
          fill="#EDEDED"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M103.8 48.05L102.03 48.14C101.32 50.14 102.37 55.14 102.84 57.58C103.11 58.97 103.08 60.04 104.34 60.04C106.63 60.03 105.14 58.45 104.44 54.93C103.94 52.46 103.92 50.63 103.8 48.05Z"
          fill="#F2F2F2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M92.87 76.72L94.89 76.54C94.93 74.78 94.17 73.27 93.82 71.47C93.03 67.28 94.18 67.64 91.98 67.61C90.76 69.18 92.35 75.1 92.87 76.72Z"
          fill="#F1F1F1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M105.73 66.41C102.69 66.29 103.45 71.09 104.56 71.76C107.51 73.54 106.44 67.68 105.73 66.41Z"
          fill="#6AAA43"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M85.49 75.23C89.54 76.2 89.13 73.06 86.62 71.5L84.78 72.46C84.81 74.05 84.86 74.05 85.49 75.23Z"
          fill="#6AAA43"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M84.25 70.49C85.96 70.29 86.85 69.26 86.76 67.29L84.57 67.25C83.74 68.56 83.84 69.01 84.25 70.49Z"
          fill="#6AAA43"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M105.41 46.49L107.08 46.57C107.36 45.82 107.53 45.36 107.14 44.49C105.25 43.3 104.69 44.84 105.41 46.49Z"
          fill="#EDEDED"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M92.83 60.45L92.86 58.06C90.24 57.3 89.66 60.99 92.83 60.45Z"
          fill="#6AAA43"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="0.0500488"
          y="-27.1285"
          width="176.829"
          height="176.829"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.835294 0 0 0 0 0.929412 0 0 0 0 0.929412 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}
